export * from './oneZeroNineFiveDataUpload.component';



// WEBPACK FOOTER //
// ./src/app/OneZeroNineFiveDataUpload/index.ts